const sasToken = localStorage.getItem('BlobSasToken') || '';
const containerName = "attachments";
const storageAccountName = "linked360storage";

export { containerName, sasToken, storageAccountName };

